<div *ngIf="isLoading$ | async" class="spinner">
    <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
</div>

<div class="finding" *ngIf="(isLoading$ | async) === false">
    <div class="finding-header">
        <div class="finding-header-title">
            <div class="finding-header-title-text" style="display: flex" appLongTextTooltip>
                {{ findingModel.rule.displayName }}
            </div>
        </div>

        <div class="finding-header-secondary-title">
            <div class="finding-header-secondary-title-property">
                <div>
                    {{ "aiFindingPage.timestampFieldName" | labelsProvider }}:
                    {{
                        findingModel.timestamp
                            | date
                                : "MMM d, y,
                    HH:mm:ss"
                    }}
                </div>
            </div>
            <div class="separator">|</div>
            <div class="finding-header-secondary-title-property">
                <div>{{ "aiFindingPage.idTitle" | labelsProvider }}</div>
                <app-copy-button class="copy-button" [value]="findingModel.id" [title]="findingModel.id" [isSecondaryFontColor]="true">
                </app-copy-button>
            </div>
        </div>

        <div class="finding-header-tertiary-title">
            <div class="finding-header-tertiary-title-property">
                <app-severity-label [severity]="findingModel.rule.severity" [smallSize]="true"></app-severity-label>
            </div>
        </div>

        <app-sidepanel-tabs class="finding-header-tabs" [tabs]="tabs" (tabOnSelection)="onTabSelect($event)"> </app-sidepanel-tabs>
    </div>

    <div class="finding-body">
        <div class="finding-body-tab" *ngIf="activeTabIndex === 0">
            <div class="finding-body-tab-card finding-details-card">
                <div class="finding-body-tab-card-title">
                    {{ "aiFindingPage.summaryCardTitle" | labelsProvider }}
                </div>
                <div>
                    {{ findingModel.rule.summary }}
                </div>
                <app-card-fields [cardFields]="findingDetailsCardFields"></app-card-fields>
                <app-anchor-link
                    [navigation]="{
                        commands: [],
                        queryParams: { q: 'threadId:' + this.findingModel.thread.id, tab: 'activity' },
                        queryParamsHandling: '',
                    }">
                    <span appLongTextTooltip>{{ "aiFindingPage.exploreThreadActivityLinkName" | labelsProvider }}</span>
                </app-anchor-link>

                <app-carousel-card
                    *ngIf="
                        relevantStepsCardFieldList.length >= 1 &&
                        (!findingModel.evidence || findingModel.evidence.length < 1 || findingModel.rule.id == 'ZN_M00031')
                    "
                    class="step-body-tab-card-inner"
                    [cardFieldsList]="relevantStepsCardFieldList"
                    titleLabelPath="aiFindingPage.relevantAgentStepsCardTitle">
                </app-carousel-card>
            </div>
            <div
                *ngIf="findingModel.evidence && findingModel.evidence.length >= 1 && findingModel.rule.id != 'ZN_M00031'"
                class="finding-body-tab-card evidence-card">
                <div class="finding-body-tab-card-title">Evidence</div>
                <app-evidence-list [evidenceList]="findingModel.evidence" [relatedSteps]="findingModel.relatedSteps"></app-evidence-list>
            </div>

            <div class="finding-body-tab-card actor-card">
                <div class="finding-body-tab-card-title">Actor Details</div>
                <app-card-fields [cardFields]="actorCardFields"></app-card-fields>
                <app-anchor-link
                    [navigation]="{
                        commands: [],
                        queryParams: { q: 'actor:' + this.findingModel.relatedSteps[0].mainActor.id, tab: 'activity' },
                        queryParamsHandling: '',
                    }">
                    <span appLongTextTooltip>{{ "aiFindingPage.exploreActorActivityLinkName" | labelsProvider }}</span>
                </app-anchor-link>
            </div>

            <div class="finding-body-tab-card risk-card">
                <div class="finding-body-tab-card-title">
                    {{ "aiFindingPage.riskReasonCardTitle" | labelsProvider }}
                </div>
                <div>{{ this.findingModel.rule.riskReason }}</div>

                <app-security-tag [tags]="owaspRiskTag"></app-security-tag>

                <app-security-tag [tags]="attackRiskTag"></app-security-tag>
            </div>

            <div class="finding-body-tab-card triage-card">
                <div class="finding-body-tab-card-title">
                    {{ "aiFindingPage.investigateSuggestionCardTitle" | labelsProvider }}
                </div>
                <app-timeline *ngIf="triageSuggestion.length > 1" [timelineItems]="triageSuggestion" [withIcons]="false"></app-timeline>
                <div *ngIf="triageSuggestion.length === 1">
                    {{ this.findingModel.rule.triageSuggestion }}
                </div>
            </div>

            <div *ngIf="this.findingModel.rule.fixSuggestion !== ''" class="finding-body-tab-card fix-card">
                <div class="finding-body-tab-card-title">
                    {{ "aiFindingPage.fixSuggestionCardTitle" | labelsProvider }}
                </div>
                <app-timeline *ngIf="fixSuggestion.length > 1" [timelineItems]="fixSuggestion" [withIcons]="false"> </app-timeline>
                <div *ngIf="fixSuggestion.length === 1">
                    {{ this.findingModel.rule.fixSuggestion }}
                </div>
            </div>
        </div>
    </div>

    <div class="no-data-container" *ngIf="showNoData && (isLoading$ | async) === false">
        <app-no-data [inDialog]="true"></app-no-data>
    </div>
</div>

<ng-template #customAgentTemplate>
    <div class="custom-agent-container">
        <img 
            *ngIf="getAiServiceIconPath() != ''"
            [src]="getAiServiceIconPath()" 
            alt="AI Service Icon" 
            class="ai-service-icon" />
        <span class="agent-name-text" appLongTextTooltip>{{ findingModel.relatedSteps[0].botDetails.displayName }}</span>
        <span class="extension-agent-text"> ({{ "aiAgentStepPage.m365CopilotExtensionAgent" | labelsProvider }})</span>
        <img 
            src="assets/images/common/info.svg" 
            alt="Info" 
            class="tooltip-icon"
            [matTooltip]="'aiAgentStepPage.m365CopilotExtensionAgentTooltip' | labelsProvider"
            matTooltipPosition="above"
            matTooltipClass="tooltip-container" />
    </div>
</ng-template>
